import { render, staticRenderFns } from "./WithdrawalEdit.vue?vue&type=template&id=1920d819&"
import script from "./WithdrawalEdit.vue?vue&type=script&lang=js&"
export * from "./WithdrawalEdit.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalEdit.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports